import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import Logo from "./Logo";
import { navLinks } from "../mock/mock";

const Header = ({ forceSolid = false }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (href) => {
    setOpen(false);
    if (href.startsWith("/")) {
      navigate(href);
      return;
    }
    if (location.pathname !== "/") {
      navigate("/" + href);
      return;
    }
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };

  const overDark = !forceSolid && !scrolled; // hero is black on home

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        overDark ? "bg-transparent" : "bg-[#F4F1EA] border-b-2 border-[#0A0A0A]"
      }`}
    >
      <div className="container-x flex items-center justify-between h-[76px]">
        <button onClick={() => go("#top")} data-cursor>
          <Logo dark={overDark} />
        </button>

        <nav className="hidden lg:flex items-center gap-7">
          {navLinks.map((l) => (
            <button
              key={l.label}
              onClick={() => go(l.to || l.href)}
              className={`mono text-[12px] font-bold uppercase tracking-[0.12em] transition-opacity hover:opacity-100 ${
                overDark ? "text-[#F4F1EA] opacity-70" : "text-[#0A0A0A] opacity-70"
              }`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:block">
          <button onClick={() => go("#contact")} className={overDark ? "btn-outline-paper" : "btn-ink"}>
            Get in Touch
          </button>
        </div>

        <button className="lg:hidden" onClick={() => setOpen(!open)} aria-label="Menu" style={{ color: overDark ? "#F4F1EA" : "#0A0A0A" }}>
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#F4F1EA] border-t-2 border-[#0A0A0A]">
          <div className="container-x py-5 flex flex-col gap-1">
            {navLinks.map((l) => (
              <button key={l.label} onClick={() => go(l.to || l.href)} className="text-left py-2.5 mono text-sm font-bold uppercase tracking-wide text-[#0A0A0A]">
                {l.label}
              </button>
            ))}
            <button onClick={() => go("#contact")} className="btn-ink mt-3 w-full">Get in Touch</button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
